export enum BankAccountTypeEnum {
  Checking,
  Savings,
  BusinessChecking,
}

export enum CheckAuthMethodEnum {
  CCD,
  PPD,
  TEL,
  WEB,
}

export class GatewayPaymentProfile {
  public CcPaymentProfileId: string;
  public AccountType: BankAccountTypeEnum;

  // billto info
  public FirstName: string;
  public LastName: string;
  public Company: string;
  public Address: string;
  public City: string;
  public State: string;
  public Zip: string;
  public Country: string;
  public Phone: string;

  // bank info
  public AccountNumber: string;
  public BankName: string;
  public RoutingNumber: string;
  public NameOnAccount: string;
  public ECheckType: CheckAuthMethodEnum;

  // cc info
  public CardNumber: string;
  public ExpirationDate: string;
  public CardCode: string;
  public CardType: string;
}

// Saved card selected = any id that isn't the new-card sentinel. Opaque: works for numeric ids and GUIDs.
export function isSavedCardSelected(id: string | number | null | undefined): boolean {
  return id != null && id !== '' && String(id) !== '0';
}
